import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      
      <header>
        <h1>Degen Den Academy – Cyber Security Lab</h1>
        <p className="subtitle1">Where minds meet malware — safely.</p>
      </header>

    </section>
  );
}

export default Hero;
